<template>
  <svg id="Camada_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.91 28.14">
    <g id="Camada_1-2" data-name="Camada_1">
      <g>
        <path d="M20.37,28.14c-5.16,0-10.33,0-15.49,0C1.85,28.14,0,26.3,0,23.27c0-6.15,0-12.3,0-18.45C0,1.86,1.87,0,4.85,0c10.41,0,20.81,0,31.22,0,2.98,0,4.84,1.85,4.84,4.82,0,6.18,0,12.35,0,18.53,0,2.92-1.88,4.78-4.8,4.78-5.24,0-10.49,0-15.73,0ZM38.35,9.65H2.6c-.01.16-.03.26-.03.37,0,4.5,0,9,0,13.5,0,1.3.79,2.06,2.12,2.06,10.51,0,21.02,0,31.54,0,1.36,0,2.11-.77,2.12-2.14,0-1.46,0-2.93,0-4.39,0-3.11,0-6.22,0-9.39ZM38.35,7c0-.71,0-1.32,0-1.93,0-1.86-.63-2.5-2.48-2.5-10.27,0-20.54,0-30.81,0-.24,0-.48-.01-.72,0-.83.07-1.6.64-1.69,1.45-.11.98-.03,1.99-.03,2.98h35.73Z"/>
        <path d="M8.37,21.75c-1.64,0-1.98-.33-1.98-1.93,0-1.57.34-1.92,1.9-1.92,1.61,0,1.94.33,1.94,1.96,0,1.52-.36,1.88-1.86,1.88Z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PaymentIcon'
}
</script>
